import { render, staticRenderFns } from "./ReferenceOverviewStep.vue?vue&type=template&id=3985a78e&scoped=true"
import script from "./ReferenceOverviewStep.vue?vue&type=script&lang=js"
export * from "./ReferenceOverviewStep.vue?vue&type=script&lang=js"
import style0 from "./ReferenceOverviewStep.vue?vue&type=style&index=0&id=3985a78e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3985a78e",
  null
  
)

export default component.exports